import type { PropsWithChildren } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { Nullable } from 'corgi-types';
import { width } from 'styled-system';

import { Viewport } from '../../enums/Viewport';
import { Flex } from '../Flex';
import BackButton from './BackButton';
import ProceedButton from './ProceedButton';
import StickyNavigation from './StickyNavigation';

interface ButtonGroupProps {
  backLinkUrl: Nullable<string>;
  backLinkText: string;
  proceedButtonText: string;
  isLoading: boolean;
  isDisabled: boolean;
  isProceedVisible: boolean;
  onProceedClick: () => void;
  onBackLinkClick?: () => void;
}

const ButtonsContainer = styled(Flex)``;

const ButtonsWrapper = styled.div<any>`
  ${width};
`;

const StyledBackButton = styled(BackButton)``;
const backButtonStyles = {
  display: 'flex',
};

const StyledProceedButton = styled(ProceedButton)`
  ${width};
`;
const proceedButtonStyles = {
  display: 'flex',
  width: 1,
  boxShadow: 'none',
  mb: ['sp_12', 'sp_8'],
};

const buttonContainerClassName = 'reclamation-overview-button-container';

const ButtonGroup = ({
  backLinkUrl,
  backLinkText,
  proceedButtonText,
  isLoading,
  isDisabled,
  isProceedVisible,
  onProceedClick,
  onBackLinkClick,
  children,
}: PropsWithChildren<ButtonGroupProps>) => {
  return (
    <>
      {isProceedVisible && (
        <StickyNavigation
          proceedButtonText={proceedButtonText}
          previousHref={backLinkUrl}
          previousAriaLabel={backLinkText}
          isProceedDisabled={isDisabled}
          isProceedLoading={isLoading}
          viewport={Viewport.MobileTablet}
          dependsOn={`.${buttonContainerClassName}`}
          onProceedButtonClick={onProceedClick}
        />
      )}

      <ButtonsContainer
        flex={1}
        mt={['sp_16', 'sp_0', 'sp_20']}
        className={buttonContainerClassName}
      >
        <ButtonsWrapper width={1}>
          {isProceedVisible && (
            <StyledProceedButton
              disabled={isDisabled}
              isLoading={isLoading}
              onClick={onProceedClick}
              {...proceedButtonStyles}
            >
              {proceedButtonText}
            </StyledProceedButton>
          )}
          {backLinkUrl && (
            <StyledBackButton href={backLinkUrl} onClick={onBackLinkClick} {...backButtonStyles}>
              {backLinkText}
            </StyledBackButton>
          )}
          {children}
        </ButtonsWrapper>
      </ButtonsContainer>
    </>
  );
};

export default ButtonGroup;
